const initialState = {
    dataBeritas:[],
    dataBerita:'',
    modalBerita: false,
    formBerita: {
        Id:null,
        Name: '',
        Description: '',
        FileLogo: '',
        FileLogoUpload: ''
    }
}

const BeritaReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_BERITA':
            return { ...state, modalBerita: action.payload }
        case 'DATA_BERITAS':
            return { ...state, dataBeritas: action.payload }
        case 'DATA_BERITA':
            return { ...state, dataBerita: action.payload }
        case 'RESET_FORM_BERITA':
            return { ...state, formBerita: initialState.formBerita }
        case 'FORM_BERITA':
            return {
                ...state,
                formBerita: {
                    ...state.formBerita,
                    [action.formType]: action.formValue
                }
            }
        default:
            return state
    }
}

export default BeritaReducer;